import $ from 'jquery';

export default class Tabs {
  constructor($c) {
    $c.on('click', '.js-tabs-button', (e) => {
      e.preventDefault();

      const $button = $(e.currentTarget);
      Tabs.showTab($button);
    });
  }
  static showTab($button) {
    const group = $button.data('group');
    const groupSelector = `[data-group=${group}]`;
    const targetSelector = $button.attr('href');
    const $buttons = $(`.js-tabs-button${groupSelector}`);
    const $targets = $(`.js-tabs-target${groupSelector}`);
    const $target = $targets.filter(targetSelector);
    const $scroll = $button.closest('.js-tabs-scroll');
    const $item = $button.closest('.js-tabs-item');

    $targets.removeClass('_active');
    $target.addClass('_active');
    Tabs.updateWidgets($target);

    $buttons.removeClass('_active');
    $button.addClass('_active');

    Tabs.centeringTabs($scroll, $item);
  }
  static updateWidgets($target) {
    $target.find('.js-works').data('Works').update();
  }
  static centeringTabs($scroll, $item) {
    const itemOffset = ($item.position() || {}).left;
    const halfScrollWidth = $scroll.width() / 2;
    const halfItemWidth = $item.outerWidth() / 2;
    const scrollLeft = (itemOffset - halfScrollWidth) + halfItemWidth;

    $scroll.animate({ scrollLeft }, 500);
  }
}
